import { useFeatureFlagEnabled } from '@posthog/react';
import { useOrgResolvedFlag } from './useOrgResolvedFlag';

/** PostHog flag key gating the new Conflict Summary page. Evaluated against the active `organization` group. */
export const NEW_CONFLICT_SUMMARY_FLAG = 'new-conflict-summary-enabled';

/**
 * New Conflict Summary gate. Fail-closed: `undefined`/`false` from PostHog keeps the feature off.
 * Prefer {@link useNewConflictSummaryFlag} when the *resolved-vs-loading* distinction matters
 * (the route guard must not redirect a flag-ON user before flags load).
 */
export function useNewConflictSummaryEnabled(): boolean {
  return useFeatureFlagEnabled(NEW_CONFLICT_SUMMARY_FLAG) === true;
}

/**
 * The flag with its **resolution** state, for the route guard on `/conflictsSummaryV2`.
 * See {@link useOrgResolvedFlag} for why `resolved` is per-org and flag-agnostic.
 */
export function useNewConflictSummaryFlag(): { resolved: boolean; enabled: boolean } {
  return useOrgResolvedFlag(NEW_CONFLICT_SUMMARY_FLAG);
}
